/**
 * Tool usage reporting.
 *
 * Dispatched as a DOM CustomEvent rather than calling an analytics function
 * directly, so nothing in this bundle has to know whether an analytics layer
 * exists. /analytics.js listens for it; when that file is absent — no GTM
 * container configured, or a visitor who refused consent — the event is
 * dispatched into the void and the tool is unaffected.
 *
 * Fire this only where a real result has been rendered. The tools have error
 * paths (an ambiguous birth time, an unresolvable place) that render a
 * perfectly good explanation and are NOT completions — counting those would
 * make the funnel look healthier the more often the tool failed.
 */
export type ToolName = 'vastu-direction' | 'birth-chart' | 'lucky-colors' | 'kundli-matching';

export function reportToolComplete(tool: ToolName): void {
  try {
    document.dispatchEvent(
      new CustomEvent('vterior:tool-complete', { detail: { tool } }),
    );
  } catch {
    /* A tool must never break because a measurement call did. */
  }
}

/**
 * Fired on the first submit of a tool's form in a page view. With
 * tool_complete this gives the start→complete drop-off, which is the tool's
 * real UX metric (REDESIGN_PLAN.md §7); for the instant tools the two track
 * each other, for the birth chart the gap is the form's difficulty.
 */
export function reportToolStart(tool: ToolName): void {
  try {
    document.dispatchEvent(
      new CustomEvent('vterior:tool-start', { detail: { tool } }),
    );
  } catch {
    /* ignore */
  }
}

/**
 * Fired when a visitor clicks the consultation bridge ON a rendered result —
 * the tool→booking attribution the funnel plan asks for. The navigation
 * itself also produces the generic booking_click; `verdict` is what makes
 * this one worth its own name.
 */
export function reportToolCta(tool: ToolName, verdict: string): void {
  try {
    document.dispatchEvent(
      new CustomEvent('vterior:tool-cta', { detail: { tool, verdict } }),
    );
  } catch {
    /* ignore */
  }
}
